import apiClient from './client';
import type { Course, CourseMember } from '@voc-system/shared';

export interface CreateCourseDto {
  name: string;
  isPrivate: boolean;
}

export interface UpdateCourseDto {
  name?: string;
  isPrivate?: boolean;
}

export interface CourseWithStats extends Course {
  role: 'owner' | 'editor' | 'member';
  memberCount: number;
  vocabularyCount: number;
}

export const coursesApi = {
  getAll: async (): Promise<CourseWithStats[]> => {
    const { data } = await apiClient.get('/courses');
    return data;
  },

  getById: async (id: number): Promise<Course> => {
    const { data } = await apiClient.get(`/courses/${id}`);
    return data;
  },

  create: async (dto: CreateCourseDto): Promise<Course> => {
    const { data } = await apiClient.post('/courses', dto);
    return data;
  },

  update: async (id: number, dto: UpdateCourseDto): Promise<Course> => {
    const { data } = await apiClient.put(`/courses/${id}`, dto);
    return data;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/courses/${id}`);
  },

  join: async (id: number): Promise<void> => {
    await apiClient.post(`/courses/${id}/join`);
  },

  leave: async (id: number): Promise<void> => {
    await apiClient.post(`/courses/${id}/leave`);
  },

  getMembers: async (id: number): Promise<CourseMember[]> => {
    const { data } = await apiClient.get(`/courses/${id}/members`);
    return data;
  },

  grantEditor: async (courseId: number, userId: number): Promise<void> => {
    await apiClient.post(`/courses/${courseId}/members/${userId}/editor`);
  },

  revokeEditor: async (courseId: number, userId: number): Promise<void> => {
    await apiClient.delete(`/courses/${courseId}/members/${userId}/editor`);
  },

  inviteMember: async (courseId: number, nickname: string): Promise<{ success: boolean; displayname: string }> => {
    const { data } = await apiClient.post(`/courses/${courseId}/members`, { nickname });
    return data;
  },

  removeMember: async (courseId: number, userId: number): Promise<void> => {
    await apiClient.delete(`/courses/${courseId}/members/${userId}`);
  },
};
